import { trustStats } from '../data';

export default function Trust() {
  return (
    <section id="about" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 pb-4 pt-2 md:px-6 md:pb-6">
        <div className="overflow-hidden rounded-3xl bg-foreground-900">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="flex flex-col justify-center p-6 text-background-50 md:p-10">
              <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
                <i className="ri-open-arm-line"></i>关于今日看瓜
              </p>
              <h2 className="font-heading text-2xl font-bold leading-tight md:text-3xl">
                把散落各处的瓜，收进一个首页
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-50/80 md:text-base">
                每天打开一次今日看瓜，实时热点榜与快讯流就能帮你把分散在各平台的今日爆料与热门话题聚到一起。我们没有铺天盖地的猜测，只有公开信源的整理与时间线。
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {['全网热门聚合', '公开信源优先', '实时滚动刷新', '免费无门槛'].map((t) => (
                  <span
                    key={t}
                    className="inline-flex items-center gap-1.5 rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1 text-xs text-background-50/90"
                  >
                    <i className="ri-check-line text-accent-400"></i>
                    {t}
                  </span>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-px border-t border-background-50/10 bg-background-50/10 lg:border-l lg:border-t-0">
              {trustStats.map((stat) => (
                <div key={stat.label} className="flex flex-col justify-center bg-foreground-900 p-6 md:p-8">
                  <span className="font-heading text-3xl font-bold text-accent-400 md:text-4xl">
                    {stat.num}
                  </span>
                  <span className="mt-1.5 text-sm text-background-50/70">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}